import React from 'react';

/**
 * Eager fallback while the barcode-search chunk downloads.
 * Keep this free of the modal/detector graph so QuickSearch can show it immediately.
 */
const BarcodeSearchChunkFallback = () => (
  <span className="BarcodeSearchChunkFallback" aria-hidden="true" />
);

export default BarcodeSearchChunkFallback;
